module.exports = __webpack_public_path__ + "static/p4-26e40a6973e4c250144b3766f41aa05f.jpg";